import React from 'react';
import _ from 'lodash';
import Griddle from 'griddle-react';
import {Map} from 'immutable';
import {PermissionRequired, TableSearch} from '../../components';
import {search} from '../../components/TableSearch/TableSearch';
import {FbosAction} from '../../actions';
import {Activities} from '../../constants';
import {FbosStore} from '../../stores';

export default React.createClass({
  propTypes: {
    fbos:     React.PropTypes.array,
    loadingStatus: React.PropTypes.object
  },

  getDefaultProps: function () {
    return {
      fbos:     [],
      loadingStatus: Map({
        status:  'loading',
        message: 'Fetching data from server. Please wait.',
      })
    }
  },

  getInitialState() {
    return {
      fbos: this.props.fbos
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(nextProps.fbos, this.props.fbos)
      || this.props.loadingStatus.get('status') !== nextProps.loadingStatus.get('status');
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchParams.size > 0) {
      let filteredFbos = search([...nextProps.fbos], nextProps.searchParams.toJS())
      this.setState({fbos: filteredFbos})
    } else {
      this.setState({fbos: nextProps.fbos})
    }
    this.forceUpdate();
  },

  componentWillUnmount() {
    FbosStore.setState({ search: Map() });
  },

  render() {
    return (
      <PermissionRequired requiredRoles={Activities.READ_FBOS} user={this.props.user}>
        <TableSearch
          user={this.props.user}
          requiredRoles={Activities.WRITE_FBOS}
          columnMetadata={this.props.columnMetadata}
          onSearch={this.handleSearch}
          isNewButton={this.props.isNewButton}
          newButtonText="New fbo"
          onNew={this.props.onNew}
        />
        <Griddle
          initialSort="name"
          initialSortAscending={true}
          results={this.state.fbos}
          tableClassName="table middle-td"
          resultsPerPage={20}
          filterPlaceholderText="Search"
          columnMetadata={this.props.columnMetadata}
          columns={this.props.columnNames}
        />
      </PermissionRequired>
    )
  },

  handleSearch(e) {
    let {name, value} = e.target;
    FbosAction.search(name, value);
  }
});
